import React from "react";
import styles from "./AboutSection.module.css";
import myImg from "./../../assets/profile.jpg";
import html from "./../../assets/html.png";
import css from "./../../assets/css.png";
import js from "./../../assets/js.png";
import reactLogo from "./../../assets/react.png";
import redux from "./../../assets/redux.png";
import next from "./../../assets/nextjs.png";
import nodeJs from "./../../assets/nodejs.png";
import express from "./../../assets/express.png";
import mongo from "./../../assets/mongo.png";
import Button from "../UI/Button";

const AboutSection = (props) => {
  return (
    <section className={styles.secAbout} id="about">
      <h2>
        <span>ABOUT</span>
      </h2>
      <div className={styles.container}>
        <div className={styles.textDiv}>
          <div className={styles.about}>
            <h3>About me</h3>
            <p>
            My name is Mohamed Magdy, and I am currently pursuing a degree in Electrical Engineering. I had the valuable opportunity to explore my passion for programming through an internship with <em>Albonyan Almarsos</em>, which played a pivotal role in shaping me into a proficient full-stack developer.
            </p>
          </div>
          <div className={styles.skills}>
            <h3>Skills</h3>
            <div className={styles.skillContainer}>
              <div className={styles.skillImg}>
                <img src={html} alt="img" />
              </div>
              <div className={styles.skillImg}>
                <img src={css} alt="img" />
              </div>
              <div className={styles.skillImg}>
                <img src={js} alt="img" />
              </div>
              <div className={styles.skillImg}>
                <img src={mongo} alt="img" />
              </div>
              <div className={styles.skillImg}>
                <img src={express} alt="img" />
              </div>
              <div className={styles.skillImg}>
                <img src={reactLogo} alt="img" />
              </div>
              <div className={styles.skillImg}>
                <img src={nodeJs} alt="img" />
              </div>
              <div className={styles.skillImg}>
                <img src={redux} alt="img" />
              </div>
              <div className={styles.skillImg}>
                <img src={next} alt="img" />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.imgDiv}>
          <img src={myImg} alt="img" />
          <Button
            color="black"
            target="_blank"
            href="https://drive.google.com/file/d/1jy0f_Wy7eO2HS3A5d25mbuF-zwpb-Yq-/view?usp=drive_link"
          >
            Download resume
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
